export function CompetitionLabelHelper(competition) {
    return competition.replace('Uluslararası Kulüpler ', '')
        .replace('UEFA Şampiyonlar Ligi Elemeler', 'UEFA Şampiyonlar Ligi Elemeleri')
        .replace('UEFA Avrupa Ligi, Elemeler', 'UEFA Avrupa Ligi Elemeleri')
        .replace('KuzOrtAmk Lig', 'K. Orta Amerika Ligi')
        .replace('Kuz.Ort. Amerika Lig', 'K. Orta Amerika Ligi');
}
;
